import React, { Fragment } from 'react';
import { createClient } from '../../prismicio';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import { saasModernTheme } from 'common/theme/saasModern';
import ResetCSS from 'common/assets/css/style';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/SaasModern/sassModern.style';
import Navbar from 'containers/SaasModern/Navbar';
import Footer from 'containers/SaasModern/Footer';
import MetaHead from 'common/components/MetaHead';
import { getPrismicLanguage } from 'utils/getPrismicLanguage';
import { SliceZone } from '@prismicio/react';
import { components } from 'slices';

export default function Page({ pages, locale }) {
  const metaTitle = pages[0]?.data?.meta_title;
  const metaDescription = pages[0]?.data?.meta_description;

  return (
    <ThemeProvider theme={saasModernTheme}>
      <Fragment>
        <MetaHead title={metaTitle} description={metaDescription} />
        <ResetCSS />
        <GlobalStyle />
        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar locale={locale} />
            </DrawerProvider>
          </Sticky>
          {pages.map((page) => (
            <div key={page.id}>
              {page.data?.slices && (
                <SliceZone slices={page.data.slices} components={components} />
              )}
            </div>
          ))}
          <Footer locale={locale} />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
}

export async function getStaticProps({ previewData, locale }) {
  const client = createClient({ previewData });
  const prismicLanguage = getPrismicLanguage(locale);

  try {
    const pages = await client.getAllByType('new_page_use_case', {
      lang: prismicLanguage,
    }) || [];

    return {
      props: {
        pages: pages || [],
        locale,
      },
    };
  } catch (error) {
    console.error('Error fetching use case documents:', error);
    
    // Return safe fallback data instead of notFound
    return {
      props: {
        pages: [],
        locale,
      },
    };
  }
}
